import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import { PrestadorLayout } from '../layouts/PrestadorLayout';
import { DashboardFinanceiro } from '../../features/dashboard/pages/DashboardFinanceiro';
import FeedbackPage from '../../features/feedback/pages/FeedbackPage';
import MeusFeedbacksPage from '../../features/feedback/pages/MeusFeedbacksPage';
import RhFeedbacksPage from '../../features/feedback/pages/RhFeedbacksPage';
import AdminPage from '../../features/admin/pages/AdminPage';
import UsersPage from '../../features/usuarios/pages/UsersPage';
import MeuGestorPage from '../../features/usuarios/pages/MeuGestorPage';
import MeusColaboradoresPage from '../../features/usuarios/pages/MeusColaboradoresPage';
import MeusDocumentosPage from '../../features/usuarios/pages/MeusDocumentosPage';
import CompaniesPage from '../../features/empresas/pages/CompaniesPage';
import NotasFiscaisPage from '../../features/notas-fiscais/pages/NotasFiscaisPage';
import GestaoNotasFiscaisPage from '../../features/notas-fiscais/pages/GestaoNotasFiscaisPage';
import FornecedoresComprasPage from '../../features/compras-fornecedores/pages/FornecedoresComprasPage';
import ComprasPage from '../../features/compras/pages/ComprasPage';
import NovaSolicitacaoPage from '../../features/compras/pages/NovaSolicitacaoPage';
import SolicitacaoDetalhePage from '../../features/compras/pages/SolicitacaoDetalhePage';
import AprovacoesComprasPage from '../../features/compras/pages/AprovacoesComprasPage';
import RelatoriosComprasPage from '../../features/compras/pages/RelatoriosComprasPage';
import PortalFornecedorPage from '../../features/compras-fornecedores/pages/PortalFornecedorPage';
import ChangePasswordPage from '../../features/usuarios/pages/ChangePasswordPage';
import MeuCadastroPage from '../../features/prestador/pages/MeuCadastroPage';
import MeusContratosPage from '../../features/prestador/pages/MeusContratosPage';
import AtivosHomePage from '../../features/ativos/pages/AtivosHomePage';
import MovimentacoesPage from '../../features/ativos/pages/MovimentacoesPage';
import CustodiariosPage from '../../features/ativos/pages/CustodiariosPage';
import AtivoDetailPage from '../../features/ativos/pages/AtivoDetailPage';
import { licencaUrl } from '../../features/ativos/utils/links';
import AlertasPage from '../../features/ativos/pages/AlertasPage';
import InventarioDetailPage from '../../features/ativos/pages/InventarioDetailPage';
import InventarioReportPage from '../../features/ativos/pages/InventarioReportPage';
import ClientesPage from '../../features/clientes/pages/ClientesPage';
import ClienteDetalhePage from '../../features/clientes/pages/ClienteDetalhePage';
import AprovacoesPendentesPage from '../../features/clientes/pages/AprovacoesPendentesPage';
import FusaoDuplicidadesPage from '../../features/clientes/pages/FusaoDuplicidadesPage';
import OportunidadesPage from '../../features/oportunidades/pages/OportunidadesPage';
import OportunidadeDetalhePage from '../../features/oportunidades/pages/OportunidadeDetalhePage';
import NovaOportunidadePage from '../../features/oportunidades/pages/NovaOportunidadePage';
import EditarOportunidadePage from '../../features/oportunidades/pages/EditarOportunidadePage';
import OportunidadesKanbanPage from '../../features/oportunidades/pages/OportunidadesKanbanPage';
import OportunidadesCardsPage from '../../features/oportunidades/pages/OportunidadesCardsPage';
import OportunidadesCalendarioPage from '../../features/oportunidades/pages/OportunidadesCalendarioPage';
import OportunidadesIndicadoresPage from '../../features/oportunidades/pages/OportunidadesIndicadoresPage';
import ContratosPage from '../../features/contratos/pages/ContratosPage';
import ContratoDetalhePage from '../../features/contratos/pages/ContratoDetalhePage';
import NovoContratoPage from '../../features/contratos/pages/NovoContratoPage';
import ContratosIndicadoresPage from '../../features/contratos/pages/ContratosIndicadoresPage';
import ContratosModelosPage from '../../features/contratos/pages/ContratosModelosPage';
import ContratosClausulasPage from '../../features/contratos/pages/ContratosClausulasPage';
import BasesComerciaisPage from '../../features/base-comercial/pages/BasesComerciaisPage';
import NovaBaseComercialPage from '../../features/base-comercial/pages/NovaBaseComercialPage';
import BaseComercialDetalhePage from '../../features/base-comercial/pages/BaseComercialDetalhePage';
import BaseComercialVersoesPage from '../../features/base-comercial/pages/BaseComercialVersoesPage';
import AprovacoesBaseComercialPage from '../../features/base-comercial/pages/AprovacoesBaseComercialPage';
import PropostasComerciaisPage from '../../features/propostas-comerciais/pages/PropostasComerciaisPage';
import NovaPropostaPage from '../../features/propostas-comerciais/pages/NovaPropostaPage';
import NovaPropostaDeOportunidadePage from '../../features/propostas-comerciais/pages/NovaPropostaDeOportunidadePage';
import PropostaDetalhePage from '../../features/propostas-comerciais/pages/PropostaDetalhePage';
import PropostaVersoesPage from '../../features/propostas-comerciais/pages/PropostaVersoesPage';
import PropostaVersaoComparacaoPage from '../../features/propostas-comerciais/pages/PropostaVersaoComparacaoPage';
import AprovacoesPropostasPage from '../../features/propostas-comerciais/pages/AprovacoesPropostasPage';
import NegociacaoPropostaPage from '../../features/propostas-comerciais/pages/NegociacaoPropostaPage';
import AdminProposalWorkflowsPage from '../../features/propostas-comerciais/pages/AdminProposalWorkflowsPage';
import type { User } from '../../shared/lib/auth';
import PerfisPage from '../../features/perfis/pages/PerfisPage';
import AreasPage from '../../features/cadastros-organizacionais/pages/AreasPage';
import CargosPage from '../../features/cadastros-organizacionais/pages/CargosPage';
import ColaboradoresPage from '../../features/pessoas/pages/ColaboradoresPage';
import NovoColaboradorPage from '../../features/pessoas/pages/NovoColaboradorPage';
import ColaboradorDetalhePage from '../../features/pessoas/pages/ColaboradorDetalhePage';
import TiposDocumentaisPage from '../../features/pessoas/pages/TiposDocumentaisPage';
import ValidacoesPage from '../../features/pessoas/pages/ValidacoesPage';
import MeusDadosPage from '../../features/pessoas/pages/MeusDadosPage';
import PortalClienteInicioPage from '../../features/clientes/pages/PortalClienteInicioPage';
import PortalClienteFeriasPage from '../../features/clientes/pages/PortalClienteFeriasPage';
import TarefasAcessoFeriasPage from '../../features/pessoas/pages/TarefasAcessoFeriasPage';
import { ClientePortalLayout } from '../layouts/ClientePortalLayout';
import AprovacoesMovimentacaoPage from '../../features/pessoas/pages/AprovacoesMovimentacaoPage';
import MotivosSituacaoPage from '../../features/pessoas/pages/MotivosSituacaoPage';
import TiposAfastamentoPage from '../../features/pessoas/pages/TiposAfastamentoPage';
import AprovacoesAfastamentoPage from '../../features/pessoas/pages/AprovacoesAfastamentoPage';
import MinhasTarefasDesligamentoPage from '../../features/pessoas/pages/MinhasTarefasDesligamentoPage';
import ModelosDesligamentoPage from '../../features/pessoas/pages/ModelosDesligamentoPage';
import ReintegracoesPendentesPage from '../../features/pessoas/pages/ReintegracoesPendentesPage';
import MotivosReintegracaoPage from '../../features/pessoas/pages/MotivosReintegracaoPage';
import MinhasFeriasPage from '../../features/pessoas/pages/MinhasFeriasPage';
import FeriasLideradoPage from '../../features/pessoas/pages/FeriasLideradoPage';
import AprovacoesFeriasPage from '../../features/pessoas/pages/AprovacoesFeriasPage';
import CalendarioFeriasPage from '../../features/pessoas/pages/CalendarioFeriasPage';
import PoliticasFeriasPage from '../../features/pessoas/pages/PoliticasFeriasPage';
import EnderecosLocalidadesPage from '../../features/pessoas/pages/EnderecosLocalidadesPage';
import FeriadosPage from '../../features/cadastros-organizacionais/pages/FeriadosPage';
import LocalidadesPage from '../../features/cadastros-organizacionais/pages/LocalidadesPage';
import RequisicoesPage from '../../features/recrutamento/pages/RequisicoesPage';
import NovaRequisicaoPage from '../../features/recrutamento/pages/NovaRequisicaoPage';
import RequisicaoDetalhePage from '../../features/recrutamento/pages/RequisicaoDetalhePage';
import FilaAprovacoesPage from '../../features/recrutamento/pages/FilaAprovacoesPage';
import VagasPage from '../../features/recrutamento/pages/VagasPage';
import ProcessoSeletivoPage from '../../features/recrutamento/pages/ProcessoSeletivoPage';
import CandidatosPage from '../../features/recrutamento/pages/CandidatosPage';
import BancoTalentosPage from '../../features/recrutamento/pages/BancoTalentosPage';
import CauCatalogPage from '../../features/cau/pages/CauCatalogPage';
import CauServicePage from '../../features/cau/pages/CauServicePage';
import CauAdminPage from '../../features/cau/pages/CauAdminPage';
import CauOpenTicketPage from '../../features/cau/pages/CauOpenTicketPage';
import CauTicketsPage from '../../features/cau/pages/CauTicketsPage';
import CauTicketDetailPage from '../../features/cau/pages/CauTicketDetailPage';
import CauWorkQueuePage from '../../features/cau/pages/CauWorkQueuePage';
import CauWorkTicketPage from '../../features/cau/pages/CauWorkTicketPage';
import CauApprovalsPage from '../../features/cau/pages/CauApprovalsPage';
import CauAccessesPage from '../../features/cau/pages/CauAccessesPage';
import CauAssetsPage from '../../features/cau/pages/CauAssetsPage';
import CauNotificationsPage from '../../features/cau/pages/CauNotificationsPage';
import CauAuditPage from '../../features/cau/pages/CauAuditPage';
import CauDashboardPage from '../../features/cau/pages/CauDashboardPage';
import CauReportsPage from '../../features/cau/pages/CauReportsPage';
import { usePermissions, FEATURES } from '../../shared/hooks/usePermissions';
import type { FeatureKey, PermissionAction } from '../../shared/lib/permissions';

/**
 * Rotas ordenadas por prioridade — a primeira que o usuário pode ver vira o
 * destino padrão. Substitui o antigo `defaultPathByRole`, que precisava de uma
 * entrada por perfil e não tinha como cobrir perfis criados após o deploy.
 */
const HOME_CANDIDATES: Array<[FeatureKey, string]> = [
  [FEATURES.dashboardPrincipal, '/dashboard'],
  [FEATURES.notasFiscaisTela, '/notas-fiscais'],
  [FEATURES.feedbacksMeus, '/meus-feedbacks'],
  [FEATURES.feedbacksRh, '/rh/feedbacks'],
  [FEATURES.ativos, '/ativos'],
  [FEATURES.cauCatalogo, '/cau'],
  [FEATURES.comprasRequisicoes, '/compras'],
  [FEATURES.fornecedores, '/compras/fornecedores'],
  [FEATURES.portalFornecedor, '/portal/fornecedor'],
  [FEATURES.usuarios, '/usuarios'],
  [FEATURES.adminHome, '/admin'],
];

interface AppRouterProps {
  user: User;
  onSignOut: () => void;
}

function RequirePasswordChange({ user }: { user: User }) {
  if (user.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}

/** `/ativos/licencas?open=<id>` (bookmarks, e-mails) → grid de ativos com o detalhe. */
function LicencasRedirect() {
  const [params] = useSearchParams();
  return <Navigate to={licencaUrl(params.get('open'))} replace />;
}

export function AppRouter({ user, onSignOut }: AppRouterProps) {
  const { can, isLoading } = usePermissions();

  const homePath =
    HOME_CANDIDATES.find(([feature]) => can(feature))?.[1] ?? '/dashboard';

  /**
   * Gate de rota por permissão. Enquanto as permissões carregam, não redireciona
   * — mandar o usuário para a home só porque a resposta ainda não chegou faria
   * um deep-link legítimo perder o destino.
   */
  function guard(element: React.ReactElement, feature: FeatureKey, action: PermissionAction = 'view') {
    if (isLoading) return null;
    return can(feature, action) ? element : <Navigate to={homePath} replace />;
  }

  /**
   * Gate que aceita alternativas — libera se **qualquer** feature casar.
   *
   * Existe para a fila de aprovações do Recrutamento: ela serve os cinco
   * passos da cadeia, e quem aprova só pelo Financeiro não tem
   * `recrutamento.requisicoes`. Um gate de feature única esconderia a
   * tela exatamente de quem precisa dela.
   */
  function guardAny(
    element: React.ReactElement,
    features: FeatureKey[],
    action: PermissionAction = 'view',
  ) {
    if (isLoading) return null;
    return features.some((feature) => can(feature, action)) ? (
      element
    ) : (
      <Navigate to={homePath} replace />
    );
  }

  /**
   * Notas fiscais são do colaborador PJ; CLT não acessa mesmo tendo a
   * permissão. O regime não é perfil (vive em `employmentType`), então
   * continua sendo um filtro à parte.
   */
  function guardPjCollaborator(element: React.ReactElement, feature: FeatureKey) {
    if (user.role === 'collaborator' && user.employmentType === 'clt') {
      return <Navigate to={homePath} replace />;
    }
    return guard(element, feature);
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Rota de troca de senha — fora do MainLayout */}
        <Route path="/change-password" element={<ChangePasswordPage />} />

        {/* Rotas protegidas — bloqueadas se mustChangePassword */}
        <Route element={<RequirePasswordChange user={user} />}>
          {/* Portal Prestador PJ — layout dedicado */}
          {user.role === 'prestador_pj' && (
            <Route
              element={
                <PrestadorLayout user={user} onSignOut={onSignOut}>
                  <Outlet />
                </PrestadorLayout>
              }
            >
              <Route path="/prestador/cadastro" element={<MeuCadastroPage />} />
              <Route path="/prestador/contratos" element={<MeusContratosPage />} />
              <Route path="/prestador/*" element={<Navigate to="/prestador/cadastro" replace />} />
              <Route path="/" element={<Navigate to="/prestador/cadastro" replace />} />
              <Route path="*" element={<Navigate to="/prestador/cadastro" replace />} />
            </Route>
          )}

          {/* Portal do cliente — usuário externo (perfil `cliente`) */}
          {user.role === 'cliente' && (
            <Route
              element={
                <ClientePortalLayout user={user} onSignOut={onSignOut}>
                  <Outlet />
                </ClientePortalLayout>
              }
            >
              <Route path="/portal-cliente" element={<PortalClienteInicioPage />} />
              <Route path="/portal-cliente/ferias" element={<PortalClienteFeriasPage />} />
              <Route path="*" element={<Navigate to="/portal-cliente" replace />} />
            </Route>
          )}

          {/* Demais roles — MainLayout */}
          {user.role !== 'prestador_pj' && user.role !== 'cliente' && (
            <Route element={<MainLayout user={user} onSignOut={onSignOut}><Outlet /></MainLayout>}>
              <Route path="/" element={<Navigate to={homePath} replace />} />
              <Route path="/dashboard" element={guard(<DashboardFinanceiro />, FEATURES.dashboardPrincipal)} />
              <Route path="/notas-fiscais" element={guardPjCollaborator(<NotasFiscaisPage />, FEATURES.notasFiscaisTela)} />
              <Route path="/notas-fiscais/gestao" element={guard(<GestaoNotasFiscaisPage />, FEATURES.notasFiscaisLiberacao)} />
              <Route path="/financeiro" element={guard(<DashboardFinanceiro />, FEATURES.dashboardFinanceiro)} />
              <Route path="/feedback" element={guard(<FeedbackPage />, FEATURES.feedbacksAvaliar)} />
              <Route path="/meus-feedbacks" element={guard(<MeusFeedbacksPage />, FEATURES.feedbacksMeus)} />
              <Route path="/rh/feedbacks" element={guard(<RhFeedbacksPage />, FEATURES.feedbacksRh)} />
              <Route path="/usuarios" element={guard(<UsersPage />, FEATURES.usuarios)} />
              <Route path="/meu-gestor" element={guard(<MeuGestorPage />, FEATURES.meuGestor)} />
              <Route path="/meus-colaboradores" element={guard(<MeusColaboradoresPage />, FEATURES.meusColaboradores)} />
              <Route path="/meus-documentos" element={guard(<MeusDocumentosPage />, FEATURES.meusDocumentos)} />
              <Route path="/meus-dados" element={guard(<MeusDadosPage />, FEATURES.meusDocumentos)} />
              <Route path="/minhas-ferias" element={guard(<MinhasFeriasPage />, FEATURES.meusDocumentos)} />
              <Route path="/meus-colaboradores/:userId/ferias" element={guard(<FeriasLideradoPage />, FEATURES.meusColaboradores)} />
              <Route path="/empresas" element={guard(<CompaniesPage />, FEATURES.empresas)} />
              <Route path="/cau" element={guard(<CauCatalogPage />, FEATURES.cauCatalogo)} />
              <Route path="/cau/catalogo/:id" element={guard(<CauServicePage />, FEATURES.cauCatalogo)} />
              <Route path="/cau/chamados" element={guard(<CauTicketsPage />, FEATURES.cauChamados)} />
              <Route path="/cau/chamados/novo/:serviceVersionId" element={guard(<CauOpenTicketPage />, FEATURES.cauChamados, 'create')} />
              <Route path="/cau/chamados/rascunho/:draftId" element={guard(<CauOpenTicketPage />, FEATURES.cauChamados, 'edit')} />
              <Route path="/cau/chamados/:id" element={guard(<CauTicketDetailPage />, FEATURES.cauChamados)} />
              <Route path="/cau/atendimento" element={guard(<CauWorkQueuePage />, FEATURES.cauAtendimento)} />
              <Route path="/cau/atendimento/:id" element={guard(<CauWorkTicketPage />, FEATURES.cauAtendimento)} />
              <Route path="/cau/aprovacoes" element={guard(<CauApprovalsPage />, FEATURES.cauAprovacoes)} />
              <Route path="/cau/acessos" element={guard(<CauAccessesPage />, FEATURES.cauAcessos)} />
              <Route path="/cau/ativos" element={guard(<CauAssetsPage />, FEATURES.cauAtivos)} />
              <Route path="/cau/notificacoes" element={guard(<CauNotificationsPage />, FEATURES.cauChamados)} />
              <Route path="/cau/auditoria" element={guard(<CauAuditPage />, FEATURES.cauAuditoria)} />
              <Route path="/cau/dashboard" element={guard(<CauDashboardPage />, FEATURES.cauDashboard)} />
              <Route path="/cau/relatorios" element={guard(<CauReportsPage />, FEATURES.cauRelatorios)} />
              <Route path="/cau/configuracoes" element={guard(<CauAdminPage />, FEATURES.cauConfiguracoes)} />
              <Route path="/custodiarios" element={guard(<CustodiariosPage />, FEATURES.ativosCustodiarios)} />
              <Route path="/compras" element={guard(<ComprasPage />, FEATURES.comprasRequisicoes)} />
              <Route path="/compras/solicitacoes/nova" element={guard(<NovaSolicitacaoPage />, FEATURES.comprasRequisicoes, 'create')} />
              <Route path="/compras/solicitacoes/:id" element={guard(<SolicitacaoDetalhePage />, FEATURES.comprasRequisicoes)} />
              <Route
                path="/compras/aprovacoes"
                element={guardAny(
                  <AprovacoesComprasPage />,
                  [
                    FEATURES.comprasAprovacaoGestor,
                    FEATURES.comprasAprovacaoFinanceiro,
                    FEATURES.comprasAprovacaoGovernanca,
                    FEATURES.comprasAprovacaoDiretoria,
                  ],
                  'edit',
                )}
              />
              <Route path="/compras/relatorios" element={guard(<RelatoriosComprasPage />, FEATURES.comprasRelatorios)} />
              <Route path="/compras/fornecedores" element={guard(<FornecedoresComprasPage />, FEATURES.fornecedores)} />
              {/* Tela home unificada com abas Dashboard | Listar | Inventário */}
              <Route path="/ativos" element={guard(<AtivosHomePage />, FEATURES.ativos)} />
              {/* Redirects das rotas antigas — bookmarks e e-mails continuam funcionando */}
              <Route path="/ativos/dashboard" element={<Navigate to="/ativos?tab=dashboard" replace />} />
              {/* Visão global de auditoria (SPEC 03 §3.4) — filtros e export CSV.
                  Rota própria, fora das abas, pra manter o link de auditoria
                  estável (bookmarks e e-mails) e o CSV acessível no fluxo.
                  Gate em `ativos.manutencao`, o mesmo dos endpoints de
                  movimentação: `ativos.ativos` é a consulta de cadastro e não
                  deve abrir a trilha de todos os usuários. */}
              <Route path="/ativos/movimentacoes" element={guard(<MovimentacoesPage />, FEATURES.ativosManutencao)} />
              {/* Licenças vivem na grid "Listar Ativos" (issue #464): a rota
                  antiga e os deep-links de form redirecionam pra lá, com o
                  detalhe aberto quando houver `?open=`. */}
              <Route path="/ativos/licencas" element={<LicencasRedirect />} />
              <Route path="/ativos/licencas/novo" element={<Navigate to={licencaUrl()} replace />} />
              <Route path="/ativos/licencas/:id/editar" element={<Navigate to={licencaUrl()} replace />} />
              <Route path="/ativos/alertas" element={guard(<AlertasPage />, FEATURES.ativosAlertas)} />
              <Route path="/ativos/inventarios" element={<Navigate to="/ativos?tab=inventarios" replace />} />
              <Route path="/ativos/inventarios/:id" element={guard(<InventarioDetailPage />, FEATURES.ativosInventario)} />
              <Route path="/ativos/inventarios/:id/relatorio" element={guard(<InventarioReportPage />, FEATURES.ativosInventario)} />
              <Route path="/ativos/novo" element={<Navigate to="/ativos?tab=lista" replace />} />
              <Route path="/ativos/:id/editar" element={<Navigate to="/ativos" replace />} />
              <Route path="/ativos/:id" element={guard(<AtivoDetailPage />, FEATURES.ativos)} />
              <Route path="/clientes" element={guard(<ClientesPage />, FEATURES.clientes)} />
              {/* Fase D (SPEC 02 §1 — RN-COM-050): fila de aprovação de alterações
                  críticas. A route exige apenas acesso a cliente; a página faz o
                  check fino de client:approve-critical internamente. */}
              <Route path="/clientes/aprovacoes-pendentes" element={guard(<AprovacoesPendentesPage />, FEATURES.clientes)} />
              {/* Fase E (RN-COM-057): fusão de duplicidades. Route exige acesso a
                  cliente; a página checa client:merge internamente (só admin passa). */}
              <Route path="/clientes/fusao-duplicidades" element={guard(<FusaoDuplicidadesPage />, FEATURES.clientes)} />
              <Route path="/clientes/:id" element={guard(<ClienteDetalhePage />, FEATURES.clientes)} />
              {/*
                Rotas de Oportunidade (US-COM-004) migradas do RBAC velho (roles
                hardcoded via `routeFor`) para o RBAC novo (features + ações via
                `guard`). Feature `oportunidades.oportunidades` e afins vêm da
                migration `1789000000000-SeedOportunidadesFeatures` — se ela
                ainda não rodou no ambiente, o `guard` faz redirect pra home.
                Rotas literais precisam vir ANTES de `/oportunidades/:id` pra
                não serem capturadas como `id="literal"`.
              */}
              <Route path="/oportunidades" element={guard(<OportunidadesPage />, FEATURES.oportunidades)} />
              <Route path="/oportunidades/kanban" element={guard(<OportunidadesKanbanPage />, FEATURES.oportunidades)} />
              <Route path="/oportunidades/cards" element={guard(<OportunidadesCardsPage />, FEATURES.oportunidades)} />
              <Route path="/oportunidades/calendario" element={guard(<OportunidadesCalendarioPage />, FEATURES.oportunidades)} />
              <Route path="/oportunidades/indicadores" element={guard(<OportunidadesIndicadoresPage />, FEATURES.oportunidades)} />
              <Route path="/oportunidades/nova" element={guard(<NovaOportunidadePage />, FEATURES.oportunidades, 'create')} />
              <Route path="/oportunidades/:id/editar" element={guard(<EditarOportunidadePage />, FEATURES.oportunidades, 'edit')} />
              <Route path="/oportunidades/:id" element={guard(<OportunidadeDetalhePage />, FEATURES.oportunidades)} />
              {/*
                Rotas de Base Comercial (US-COM-005). Feature
                `base-comercial.bases` vem da migration
                `1789600000000-SeedBaseComercialFeatures` — se ela ainda não
                rodou no ambiente, o `guard` faz redirect pra home.
                Rotas literais antes de `/base-comercial/:id` pra não serem
                capturadas como `id="literal"`.
                Fatia 1: as páginas ainda são placeholders (ver grupos 10-12
                do tasks.md); as rotas ficam registradas desde já, no mesmo
                padrão adotado em Oportunidades.
              */}
              <Route path="/base-comercial" element={guard(<BasesComerciaisPage />, FEATURES.baseComercial)} />
              <Route path="/base-comercial/aprovacoes" element={guard(<AprovacoesBaseComercialPage />, FEATURES.baseComercialAprovacao, 'edit')} />
              <Route path="/base-comercial/nova" element={guard(<NovaBaseComercialPage />, FEATURES.baseComercial, 'create')} />
              <Route path="/base-comercial/:id/versoes" element={guard(<BaseComercialVersoesPage />, FEATURES.baseComercial)} />
              <Route path="/base-comercial/:id" element={guard(<BaseComercialDetalhePage />, FEATURES.baseComercial)} />

              {/*
                Rotas de Propostas Comerciais (US-COM-006). Feature
                `proposal.propostas` vem da migration
                `1789750000000-SeedProposalsFeatures` — se ela ainda não
                rodou no ambiente, o `guard` faz redirect pra home.
                Rotas literais antes de `/propostas/:id` pra não serem
                capturadas como `id="literal"`.
                Fatia 1: as páginas ainda são placeholders (ver grupos 14-16
                do tasks.md); as rotas ficam registradas desde já, no mesmo
                padrão adotado em Oportunidades/Base Comercial.
              */}
              <Route path="/propostas" element={guard(<PropostasComerciaisPage />, FEATURES.proposta)} />
              <Route path="/propostas/aprovacoes" element={guard(<AprovacoesPropostasPage />, FEATURES.propostaAprovar, 'edit')} />
              <Route path="/propostas/nova" element={guard(<NovaPropostaPage />, FEATURES.proposta, 'create')} />
              <Route path="/propostas/nova-de-oportunidade/:oppId" element={guard(<NovaPropostaDeOportunidadePage />, FEATURES.proposta, 'create')} />
              <Route path="/propostas/negociacao/:id" element={guard(<NegociacaoPropostaPage />, FEATURES.propostaRegistrarNegociacao, 'edit')} />
              <Route path="/propostas/:id/versoes/comparar/:vA/:vB" element={guard(<PropostaVersaoComparacaoPage />, FEATURES.proposta)} />
              <Route path="/propostas/:id/versoes" element={guard(<PropostaVersoesPage />, FEATURES.proposta)} />
              <Route path="/propostas/:id" element={guard(<PropostaDetalhePage />, FEATURES.proposta)} />
              <Route path="/admin/proposal-workflows" element={guard(<AdminProposalWorkflowsPage />, FEATURES.propostaAdminWorkflows)} />

              {/*
                Recrutamento — change `modulo-recrutamento-selecao`.
                `/requisicoes/nova` vem antes de `/requisicoes/:id` para
                não ser capturada como id, mesmo cuidado das rotas de
                Oportunidades acima.
              */}
              <Route path="/recrutamento/requisicoes" element={guard(<RequisicoesPage />, FEATURES.recrutamentoRequisicoes)} />
              <Route path="/recrutamento/requisicoes/nova" element={guard(<NovaRequisicaoPage />, FEATURES.recrutamentoRequisicoes, 'create')} />
              <Route path="/recrutamento/requisicoes/:id" element={guard(<RequisicaoDetalhePage />, FEATURES.recrutamentoRequisicoes)} />
              <Route
                path="/recrutamento/aprovacoes"
                element={guardAny(
                  <FilaAprovacoesPage />,
                  [
                    FEATURES.recrutamentoAprovacaoGestor,
                    FEATURES.recrutamentoAprovacaoRh,
                    FEATURES.recrutamentoAprovacaoFinanceiro,
                    FEATURES.recrutamentoAprovacaoDiretoria,
                    FEATURES.recrutamentoAprovacaoRecrutamento,
                  ],
                  'edit',
                )}
              />
              <Route path="/recrutamento/vagas" element={guard(<VagasPage />, FEATURES.recrutamentoPublicacao)} />
              <Route path="/recrutamento/processo-seletivo/:jobOpeningId" element={guard(<ProcessoSeletivoPage />, FEATURES.recrutamentoProcessoSeletivo)} />
              <Route path="/recrutamento/candidatos" element={guard(<CandidatosPage />, FEATURES.recrutamentoCandidatos)} />
              <Route path="/recrutamento/banco-talentos" element={guard(<BancoTalentosPage />, FEATURES.recrutamentoCandidatos)} />

              {/* Contratos Comerciais (US-COM-007). Rotas literais antes de /:id. */}
              <Route path="/contratos" element={guard(<ContratosPage />, FEATURES.contratos)} />
              <Route path="/contratos/indicadores" element={guard(<ContratosIndicadoresPage />, FEATURES.contratos)} />
              <Route path="/contratos/modelos" element={guard(<ContratosModelosPage />, FEATURES.contratosModelos)} />
              <Route path="/contratos/clausulas" element={guard(<ContratosClausulasPage />, FEATURES.contratosClausulas)} />
              <Route path="/contratos/novo" element={guard(<NovoContratoPage />, FEATURES.contratos, 'create')} />
              <Route path="/contratos/:id" element={guard(<ContratoDetalhePage />, FEATURES.contratos)} />

              <Route path="/portal/fornecedor" element={guard(<PortalFornecedorPage />, FEATURES.portalFornecedor)} />
              <Route path="/admin" element={guard(<AdminPage />, FEATURES.adminHome)} />
              <Route path="/admin/perfis" element={guard(<PerfisPage />, FEATURES.adminPerfis)} />
              <Route path="/cadastros/areas" element={guard(<AreasPage />, FEATURES.masterDataAreas)} />
              <Route path="/cadastros/cargos" element={guard(<CargosPage />, FEATURES.masterDataCargos)} />
              <Route path="/cadastros/feriados" element={guard(<FeriadosPage />, FEATURES.masterDataFeriados)} />
              <Route path="/cadastros/localidades" element={guard(<LocalidadesPage />, FEATURES.masterDataLocalidades)} />

              {/* Gestão de Pessoas — cadastro mestre (US-GP-001). Rota literal antes de /:id. */}
              <Route path="/pessoas/colaboradores" element={guard(<ColaboradoresPage />, FEATURES.pessoasColaboradores)} />
              <Route path="/pessoas/colaboradores/novo" element={guard(<NovoColaboradorPage />, FEATURES.pessoasColaboradores, 'create')} />
              <Route path="/pessoas/colaboradores/:id" element={guard(<ColaboradorDetalhePage />, FEATURES.pessoasColaboradores)} />
              <Route path="/pessoas/tipos-documentais" element={guard(<TiposDocumentaisPage />, FEATURES.pessoasTiposDocumentais)} />
              <Route path="/pessoas/aprovacoes-movimentacao" element={guard(<AprovacoesMovimentacaoPage />, FEATURES.pessoasMovimentacoesAprovacao, 'edit')} />
              <Route path="/pessoas/motivos-situacao" element={guard(<MotivosSituacaoPage />, FEATURES.pessoasSituacaoFuncional)} />
              <Route path="/pessoas/tipos-afastamento" element={guard(<TiposAfastamentoPage />, FEATURES.pessoasTiposAfastamento)} />
              <Route path="/pessoas/aprovacoes-afastamento" element={guard(<AprovacoesAfastamentoPage />, FEATURES.pessoasAfastamentosAprovacao, 'edit')} />
              <Route path="/pessoas/tarefas-desligamento" element={guardAny(<MinhasTarefasDesligamentoPage />, [FEATURES.pessoasDesligamentoTarefas, FEATURES.pessoasDesligamentos])} />
              <Route path="/pessoas/modelos-desligamento" element={guard(<ModelosDesligamentoPage />, FEATURES.pessoasDesligamentoModelos)} />
              <Route path="/pessoas/reintegracoes" element={guardAny(<ReintegracoesPendentesPage />, [FEATURES.pessoasReintegracaoAprovacao, FEATURES.pessoasReintegracaoJuridico], 'edit')} />
              <Route path="/pessoas/motivos-reintegracao" element={guard(<MotivosReintegracaoPage />, FEATURES.pessoasReintegracoes)} />
              <Route path="/pessoas/aprovacoes-ferias" element={guardAny(<AprovacoesFeriasPage />, [FEATURES.pessoasFeriasAprovacao, FEATURES.meusColaboradores])} />
              <Route path="/pessoas/acessos-ferias" element={guard(<TarefasAcessoFeriasPage />, FEATURES.pessoasFeriasAcessos)} />
              <Route path="/pessoas/calendario-ferias" element={guard(<CalendarioFeriasPage />, FEATURES.pessoasFerias)} />
              <Route path="/pessoas/politicas-ferias" element={guard(<PoliticasFeriasPage />, FEATURES.pessoasFeriasPoliticas)} />
              <Route path="/pessoas/localidades" element={guard(<EnderecosLocalidadesPage />, FEATURES.masterDataLocalidades, 'edit')} />
              <Route
                path="/pessoas/validacoes"
                element={guardAny(
                  <ValidacoesPage />,
                  [FEATURES.pessoasDocumentosValidacao, FEATURES.pessoasAlteracoesCadastrais, FEATURES.pessoasDadosBancariosValidacao],
                  'edit',
                )}
              />
              <Route path="*" element={<Navigate to={homePath} replace />} />
            </Route>
          )}
        </Route>
      </Routes>
    </Router>
  );
}
